export const DIRECTORY_LEVEL = {
    SUBCATEGORY: "subcategory",
    TOPIC: "topic",
    SUBTOPIC: "subtopic"
};

export const DIRECTORY_LEVEL_OPTIONS = [
    {
        value: DIRECTORY_LEVEL.SUBCATEGORY,
        label: "Sub-Category",
        createLabel: "Create Sub-Category",
        nameLabel: "Sub-Category Name",
        parentLabel: "Select Category",
        hint: "This will sit directly under the selected category."
    },
    {
        value: DIRECTORY_LEVEL.TOPIC,
        label: "Topic",
        createLabel: "Create Topic",
        nameLabel: "Topic Name",
        parentLabel: "Select Sub-Category",
        hint: "This will sit under the selected sub-category."
    },
    {
        value: DIRECTORY_LEVEL.SUBTOPIC,
        label: "Sub-Topic",
        createLabel: "Create Sub-Topic",
        nameLabel: "Sub-Topic Name",
        parentLabel: "Select Topic",
        hint: "This will sit under the selected topic."
    }
];

export const getDirectoryLevel = item => item?.directoryLevel || DIRECTORY_LEVEL.SUBCATEGORY;

export const getDirectoryLevelOption = level =>
    DIRECTORY_LEVEL_OPTIONS.find(option => option.value === level) || DIRECTORY_LEVEL_OPTIONS[0];

export const getParentSubcategoryUuid = item => item?.parentSubcategoryUuid || item?.parent_subcategory_uuid || "";

export const getDirectoryParent = item => item?.parentSubcategory || item?.parent_subcategory || null;

export const isDirectoryHidden = item => item?.deleted_at !== null && item?.deleted_at !== undefined;

export const getDirectoryName = item => item?.categoryName || "";

export const getAvailableDirectories = directories =>
    (directories || []).filter(item => !isDirectoryHidden(item));

export const getDirectoriesByLevel = (directories, level) =>
    getAvailableDirectories(directories).filter(item => getDirectoryLevel(item) === level);

export const getChildDirectories = (directories, categoryUuid, parentSubcategoryUuid, level) =>
    getDirectoriesByLevel(directories, level).filter(item =>
        item.categoryUuid === categoryUuid && getParentSubcategoryUuid(item) === (parentSubcategoryUuid || "")
    );

export const getDirectoryPath = (item, directories, categories) => {
    const category = categories?.find(categoryItem => categoryItem.uuid === item?.categoryUuid);
    const names = [];
    let parent = getDirectoryParent(item) ||
        directories?.find(directory => directory.uuid === getParentSubcategoryUuid(item));

    while (parent) {
        names.unshift(getDirectoryName(parent));
        parent = getDirectoryParent(parent) ||
            directories?.find(directory => directory.uuid === getParentSubcategoryUuid(parent));
    }

    return [
        category?.name,
        ...names,
        getDirectoryName(item)
    ].filter(Boolean).join(" > ");
};

export const getDirectoryParentName = (item, directories, categories) => {
    const level = getDirectoryLevel(item);
    if (level === DIRECTORY_LEVEL.SUBCATEGORY) {
        return categories?.find(categoryItem => categoryItem.uuid === item?.categoryUuid)?.name || "";
    }

    const parent = getDirectoryParent(item) ||
        directories?.find(directory => directory.uuid === getParentSubcategoryUuid(item));

    return getDirectoryName(parent);
};

export const sortDirectoriesByHierarchy = directories => {
    const levelOrder = {
        [DIRECTORY_LEVEL.SUBCATEGORY]: 1,
        [DIRECTORY_LEVEL.TOPIC]: 2,
        [DIRECTORY_LEVEL.SUBTOPIC]: 3
    };

    return [...(directories || [])].sort((a, b) => {
        const categoryComparison = (a.body_and_mind_category?.name || "").localeCompare(b.body_and_mind_category?.name || "");
        if (categoryComparison !== 0) return categoryComparison;

        const levelComparison = levelOrder[getDirectoryLevel(a)] - levelOrder[getDirectoryLevel(b)];
        if (levelComparison !== 0) return levelComparison;

        return (a.order || 0) - (b.order || 0);
    });
};
